import React, { Component } from 'react';
//import logo from './logo.svg';
import './App.css';
// import './css/bootstrap.min.css';
// import './css/demo.css';
// import './css/material-kit.css';
import './css/materialize.min.css';
import './css/style.css';
import './css/general.css';
import * as utils from './utils.js';

import TeenAI from './components/TeenAI';
import Journal from './components/journal/Journal';
import {
  BrowserRouter as Router,
  Route,
  Link,
} from 'react-router-dom';





class Main extends Component {

  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    return (
      <div className="" >
        <Route exact path="/" component={Index}/>
        <Route path="/research-teaching" component={Teaching} />
        <Route path="/projects" component={Projects} />
        <Route path="/thoughts" component={Journal} />
        <Route path="/film" component={Film}/>
        <Route path="/music" component={Music}/>
        <Route path="/paintings" component={Paintings}/>
        <Route path="/photography" component={Photography}/>
        <Route path="/about" component={About}/>
        {/* <Route path="/teenAI" component={TeenAI}/> */}
      </div>
    )
  }
}

class Index extends Component {

  constructor(props) {
    super(props);
    this.state = {};
  }
  // <span ><h1 style={{color: "white", fontWeight: "800"}}>FESTINA LENTE</h1></span>
  render() {
    return (
        <div className="section no-pad-bot" id="index-banner"
          // style={{
          //   height: "100vh",
          //   background: "linear-gradient(180deg, rgba(113,11,146, 0.45) 10%, rgba(255,255,255, 0) 70%), url('./assets/img/magicmike.jpg') no-repeat center center fixed",
          //   backgroundSize: "cover",
          //   overflowY: "auto",
          // }}
          style={{
            height: "100vh",
            background: "linear-gradient(180deg, rgba(113,11,146, 0.5) 50%, rgba(255,255,255, 0.1) 99%), url('./assets/img/rose.png') repeat center center, gold",
            // backgroundSize: "80px 60px",
            // backgroundSize: "cover",
            overflowY: "auto",
          }}
        >
          <div className="container"
          style={{
            alignItems: "center",
            justifyContent: "center",
            display: "flex",
            // height: "90%",
          }}>
              <div style={{paddingTop: 50}}>
                <ListItems views={
                  [
                    <a target="_blank" >
                      <div className="card-image">
                          <img src="assets/img/rickard_main.jpg" alt="3" />
                      </div>
                      <div className="card-content">
                        <span className="card-title activator grey-text text-darken-4">
                        Rickard Brüel Gabrielsson
                        <i className="mdi-navigation-more-vert right"></i></span>

                        <span className="grey-text text-darken-4">
                        I'm co-founder of the AI research lab <a href="http://unboxai.com" target="_blank">Unbox AI</a> together
                        with Stanford <a href="https://en.wikipedia.org/wiki/Gunnar_Carlsson">Professor Gunnar Carlsson</a> and
                        a PhD in <a href="https://www.csail.mit.edu/research/geometric-data-processing-group" target="_blank">Prof. Justin Solomon's lab</a> at MIT.
                        Before that I was part of <a href="https://geometry.stanford.edu/member/guibas/" target="_blank">Guibas Lab</a> at Stanford University.
                        I earned my BSc in Math and MSc in CS at Stanford. My goal is to understand how intelligence works.<br/>
                        
                        <br/>
                        <a href="https://scholar.google.com/citations?user=h-3VssAAAAAJ&hl=en" target="_blank">Google Scholar</a>, <a target="_blank" href="https://www.linkedin.com/in/rickard-br%C3%BCel-gabrielsson-0a61375a">LinkedIn</a>, <a target="_blank" href="https://github.com/bruel-gabrielsson">Github</a>, <a target="_blank" href="https://www.youtube.com/@Red_Blue_Green">YouTube</a><br />
                        Email: rbg [at] cs [dot] stanford [dot] edu
                        </span>
                      </div>
                    </a>
                  ,
                  <a target="_blank" >
                    <div className="card-image">
                        <img src="assets/img/lecturepic.png" alt="3" />
                        <img src="assets/img/lecturepic2.png" alt="3" />
                    </div>
                    <div className="card-content">
                      <span className="card-title activator grey-text text-darken-4">
                       MIT FUTURE OF AI: Self-Supervised Learning & Foundation Models
                      <i className="mdi-navigation-more-vert right"></i></span>
                      <span className="grey-text text-darken-4">
                        <a href="https://www.futureofai.mit.edu/" target="_blank">MIT Introductory Course on Self-Supervised Learning & Foundation Models</a> Covering:
                        ChatGPT,
                        Stable-Diffusion & Dall-E,
                        Neural Networks,
                        Supervised Learning,
                        Representation & Unsupervised Learning,
                        Reinforcement Learning,
                        Generative AI,
                        Self-Supervised Learning,
                        Foundation Models,
                        GANs (adversarial),
                        Contrastive Learning,
                        Auto-encoders,
                        Denoising & Diffusion
                      </span>
                      
                    </div>
                  </a>
                  ,
                  <a target="_blank" >
                    <div className="card-image">
                        <img src="assets/img/compress.png" alt="Compress then serve" />
                    </div>
                    <div className="card-content">
                      <span className="card-title activator grey-text text-darken-4">
                      Compress then Serve: Serving Thousands of LoRA Adapters with Little Overhead
                      <i className="mdi-navigation-more-vert right"></i></span>
                      <span className="grey-text text-darken-4">
                        <a href="https://arxiv.org/pdf/2407.00066" target="_blank">[Paper]</a>. Fine-tuning large language models (LLMs) with low-rank adaptations (LoRAs) often results in multiple LLM copies differing only in LoRA updates, posing challenges for real-time query systems. Storing many LoRAs in GPU memory is impractical, requiring frequent loading. To address this, we propose compressing LoRAs into a shared basis with specific scaling matrices, enabling efficient handling of large LoRA collections. By clustering LoRAs for better compression, our approach scales to hundreds of LoRAs, preserving performance while achieving significant throughput gains, maintaining 80% of the throughput of serving a single LoRA.
                        <br/>
                        <br/>
                        <a href="https://huggingface.co/Lots-of-LoRAs" target="_blank">We also intoroduce the world's largest open collection of LoRAs.</a>
                      </span>
                    
                      <br/>
                      <br/>
                    </div>
                  </a>
                  ,
                  <a target="_blank" >
                    <div className="card-image">
                        <img src="assets/img/DeepAugSmall.png" alt="Deep Augmentation" />
                    </div>
                    <div className="card-content">
                      <span className="card-title activator grey-text text-darken-4">
                        Deep Augmentation for Foundation Models
                      <i className="mdi-navigation-more-vert right"></i></span>
                      <span className="grey-text text-darken-4">
                        We introduce <a href="https://arxiv.org/pdf/2303.14537.pdf" target="_blank">Deep Augmentation</a>, an approach to data augmentation using dropout to dynamically transform a targeted layer within a neural network, with the option to use the stop-gradient operation, offering significant improvements in model performance and generalization. We demonstrate the efficacy of Deep Augmentation through extensive experiments on contrastive learning tasks in computer vision and NLP domains, where we observe substantial performance gains with ResNets and Transformers as the underlying models. Our experimentation reveals that targeting deeper layers with Deep Augmentation outperforms augmenting the input data, and the simple network- and data-agnostic nature of this approach enables its seamless integration into computer vision and NLP pipelines.
                      </span>
                    </div>
                  </a>
                  ,
                  <a target="_blank" >
                    <div className="card-image">
                        <img src="assets/img/tda.png" alt="3" />
                    </div>
                    <div className="card-content">
                      <span className="card-title activator grey-text text-darken-4">
                        Deep Learning & Topological Data Analysis
                      <i className="mdi-navigation-more-vert right"></i></span>
                      <span className="grey-text text-darken-4">
                        My and <a href="http://math.stanford.edu/~gunnar/" target="_blank">Professor Gunnar Carlsson</a>'s work
                        [<a href="https://arxiv.org/pdf/1810.03234.pdf" target="_blank">1</a>, <a href="https://arxiv.org/pdf/1811.01122.pdf" target="_blank">3</a>]
                        introduces an algebraic formalism to construct deep learning architectures and demonstrates how topological data analysis (TDA),
                        geometric computation, and graphs increase the transparency and performance of AI.
                        We also introduced an easy-to-use
                            topology layer for machine learning [<a href="https://arxiv.org/pdf/1905.12200.pdf" target="_blank">4</a>]
                            for differentiable persistence computations and with <a href="https://github.com/bruel-gabrielsson/TopologyLayer" target="_blank">code publically available</a>.
                      </span>
                     
                    </div>
                  </a>
                  ,
                  <a target="_blank" >
                    <div className="card-image">
                        <img src="assets/img/NLP.gif" alt="3" />
                    </div>
                    <div className="card-content">
                      <span className="card-title activator grey-text text-darken-4">
                        Large Language Models & Self-Supervised Learning
                      <i className="mdi-navigation-more-vert right"></i></span>
                      <span className="grey-text text-darken-4">
                      What makes self-supervised objectives work? What's the best self-supervision perspective on data from multiple domains?
                      Work on contrastive learning, NLP, and large language models (LLMs). Undestanding the loss objectives used in language modeling, contrastive learning, and knowledge distillation. Check out our work
                      "Relative Position Prediction as Pre-training for Text Encoders" [<a href="https://arxiv.org/pdf/2202.01145.pdf" target="_blank">7</a>] where by adapting
                      the relative position encoding paradigm in NLP to create relative labels for self-supervised learning, we seek to show superior pretraining judged by
                      performance on downstream tasks.
                      
                      </span>
                    </div>
                    <br/>
                    <br/>
                  </a>
                  ,
                  <a target="_blank" >
                    <div className="card-image">
                        <img src="assets/img/graph.png" alt="3" />
                    </div>
                    <div className="card-content">
                      <span className="card-title activator grey-text text-darken-4">
                        Universal Function Approximation on Graphs
                      <i className="mdi-navigation-more-vert right"></i></span>
                      <span className="grey-text text-darken-4">
                        In this work [<a href="https://arxiv.org/pdf/2003.06706.pdf" target="_blank">5</a>] we produce a framework for constructing universal function approximators on graph isomorphism classes. We prove how this framework comes with a collection of theoretically desirable properties and enables novel analysis. We show how this allows us to achieve state-of-the-art performance on four different well-known datasets in graph classification and separate classes of graphs that other graph-learning methods cannot. Our approach is inspired by persistent homology, dependency parsing for NLP, and multivalued functions. The complexity of the underlying algorithm is O(#edges x #nodes) and code is <a href="https://github.com/bruel-gabrielsson/universal-function-approximation-on-graphs" target="_blank">publicly available</a>.
                      </span>
                    </div>
                  </a>
                  ,
                  <a target="_blank" >
                    <div className="card-image">
                        <img src="assets/img/graphrewire.png" alt="3" />
                    </div>
                    <div className="card-content">
                      <span className="card-title activator grey-text text-darken-4">
                        Rewiring with Positional Encodings for Graph Neural Networks
                      <i className="mdi-navigation-more-vert right"></i></span>
                      <span className="grey-text text-darken-4">
                        In this work [<a href="https://arxiv.org/pdf/2201.12674.pdf" target="_blank">6</a>] we use positional encodings to expand receptive fields to any r-ring.
Our method augments the input graph with additional nodes/edges and uses positional encodings
as node and/or edge features. Thus, it is compatible with many existing GNN architectures.
We also provide examples of positional encodings that are non-invasive, i.e., there is a one-to-one map between the original and the modified graphs. Our experiments demonstrate that
extending receptive fields via positional encodings and a virtual fully-connected node significantly improves GNN performance and alleviates over-squashing using small r. We obtain
improvements across models, showing state-of-the-art performance even using older architectures than recent Transformer models adapted to graphs.
                      </span>
                    </div>
                  </a>
                  ,
                  <a target="_blank" >
                    <div className="card-image">
                        <img src="assets/img/guibas.jpg" alt="4" />
                    </div>
                    <div className="card-content">
                      <span className="card-title activator grey-text text-darken-4">
                        Functional Maps & Surface Reconstruction
                      <i className="mdi-navigation-more-vert right"></i></span>
                      <span className="grey-text text-darken-4">
                      My and <a href="https://geometry.stanford.edu/member/guibas/" target="_blank">Professor Leonidas Guibas</a>' work [<a href="https://arxiv.org/pdf/1811.12543.pdf" target="_blank">2</a>] explores synergies between computational geometry and topology and introduces a novel surface reconstruction technique that guarantees the correct topology while allowing backpropagation from topological information of any dimension.
                      </span>
                    </div>
                  </a>
                ]
                } />

                {/* <div className="col s12 m4 l4">
                    <div className="card">

                    <div className="container"
                      style={{
                        alignItems: "center",
                        justifyContent: "center",
                        display: "flex",
                        flexDirection: "row",
                      }}>
                          <img src="assets/img/DALLE1.png" alt="1" />
                          <img src="assets/img/DALLE2.png" alt="2" />
                          <img src="assets/img/DALLE3.png" alt="3" />
                          <img src="assets/img/DALLE4.png" alt="3" />
                      </div>

                      <div className="card-content">
                        <span className="card-title activator grey-text text-darken-4">
                          How I look like according to <a href="https://openai.com/dall-e-2/" target="_blank">Dall-e</a>
                        <i className="mdi-navigation-more-vert right"></i></span>
                        <span className="grey-text text-darken-4">
                        </span>
                      </div>

                      {/*<div className="card-image">
                            <img src="assets/img/rickard_laugh.JPEG" alt="3" />
                        </div>
                        <div className="card-content">
                          <span className="card-title activator grey-text text-darken-4">
                          Rickard Brüel Gabrielsson
                          <i className="mdi-navigation-more-vert right"></i></span>

                          <span className="grey-text text-darken-4">
                          I'm co-founder of the AI research lab <a href="http://unboxai.com" target="_blank">Unbox AI</a> together
                          with Stanford <a href="https://en.wikipedia.org/wiki/Gunnar_Carlsson">Professor Gunnar Carlsson</a> and
                          a PhD in <a href="https://www.csail.mit.edu/research/geometric-data-processing-group" target="_blank">Prof. Justin Solomon's lab</a> at MIT.
                          Before that I was part of <a href="https://geometry.stanford.edu/member/guibas/" target="_blank">Guibas Lab</a> at Stanford University.
                          I earned my BSc in Math and MSc in CS at Stanford. My goal is to build an applied theory for how intelligence works.<br/>
                          <a href="https://scholar.google.com/citations?user=y9Oh5XwAAAAJ&hl=en" target="_blank">Google Scholar</a>, <a target="_blank" href="https://www.linkedin.com/in/rickard-br%C3%BCel-gabrielsson-0a61375a">LinkedIn</a>, <a target="_blank" href="https://github.com/bruel-gabrielsson">Github</a><br />
                          Email: rbg [at] cs [dot] stanford [dot] com
                          </span>
                        </div> 
                    </div>
                </div>
                */}



              </div>

          </div>

        </div>
    );

  }
}

class Teaching extends Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {

    return (
      <div className="no-pad-bot section" id="index-banner"
        style={{
          height: "100vh",
          background: "linear-gradient(rgba(0, 0, 0, 147.7) -22.9%, rgba(255, 255, 255, 8.3) 19%) % % / cover white",
          //"linear-gradient(rgba(8, 93, 255, 0.3) 2%, rgba(244, 244, 66, 0) 70%) 0% 0% / cover lightblue",
          backgroundSize: "cover",
          overflowY: "auto",
        }}
      >
        <div className="container"
          style={{
            alignItems: "center",
            justifyContent: "center",
            display: "flex",
            flexDirection: "column",
          }}>
          <div style={{paddingTop: 50}}>

          <h4>Research</h4>

          <p>My overarching goal is to understand how intelligence works and what it learns. I've been focused on self-supverised learning and foundation models the past years -- before it was cool.</p>
          <p>I'm interested in systematically understanding the key problem formulations and algorithms that make AI powerful.
           This includes game theory and information theory.</p>
          <p>I believe key insights to understanding AI lie in the intersection of AI and computational geometry and topology.
          This is because of the manifold hypothesis and because geometry and topology is an intuitive language for human
          understanding of structure.</p>

          <h4>Publications</h4>


          <div style={{
            maxWidth: 1100,
            borderBottom: "1px dotted lightgrey"}}>
            <b>R. Brüel Gabrielsson</b>, J. Zhu, O. Bhardwaj, L. Choshen, K. Greenewald, ... (2024), <a href="https://arxiv.org/pdf/2407.00066.pdf" style={{textDecorationLine: "underline", color: "black", fontStyle: "italic"}} target="_blank"> 
             Compress then Serve: Serving Thousands of LoRA Adapters with Little Overhead</a>, arXiv preprint arXiv:2407.00066
          </div>
          
          <div style={{
            maxWidth: 1100,
            borderBottom: "1px dotted lightgrey"}}>
            D. Tam, M. Li, P. Yadav, <b>R. Brüel Gabrielsson</b>, J. Zhu, K. Greenewald, ... (2024), <a href="https://openreview.net/pdf?id=TiRQ4Gl4Ir" style={{textDecorationLine: "underline", color: "black", fontStyle: "italic"}} target="_blank"> 
             LLM Merging: Building LLMs Efficiently through Merging</a>, NeurIPS 2024 Competition Track
          </div>

          <div style={{
            maxWidth: 1100,
            borderBottom: "1px dotted lightgrey"}}>
            J. Zhu, K. Greenewald, K. Nadjahi, H.S.O. Borde, <b>R. Brüel Gabrielsson</b>, L. Choshen, ... (2024), <a href="https://arxiv.org/pdf/2402.16842.pdf" style={{textDecorationLine: "underline", color: "black", fontStyle: "italic"}} target="_blank"> 
             Asymmetry in Low-Rank Adapters of Foundation Models</a>, arXiv:2402.16842
          </div>

          <div style={{
            maxWidth: 1100,
            borderBottom: "1px dotted lightgrey"}}>
            K. Nadjahi, K. Greenewald, <b>R. Brüel Gabrielsson</b>, J. Solomon (2024), <a href="https://arxiv.org/pdf/2406.04047" style={{textDecorationLine: "underline", color: "black", fontStyle: "italic"}} target="_blank"> 
            Slicing Mutual Information Generalization Bounds for Neural Networks</a>, arXiv:2406.04047
          </div>

          <div style={{
            //fontFamily: "Baskerville, 'Baskerville Old Face', 'Goudy Old Style', Garamond, 'Times New Roman', serif",
            maxWidth: 1100,
            //fontSize: 16,
            borderBottom: "1px dotted lightgrey"}} >
            <b>R. Brüel Gabrielsson</b>,  Tongzhou Wang, Manel Baradad (2023), <a href="https://arxiv.org/pdf/2303.14537.pdf" style={{textDecorationLine: "underline", color: "black", fontStyle: "italic"}} target="_blank">Deep Augmentation: Enhancing Self-Supervised Learning through
Transformations in Higher Activation Space</a>, arXiv:2303.14537
          </div>

          <div style={{
            //fontFamily: "Baskerville, 'Baskerville Old Face', 'Goudy Old Style', Garamond, 'Times New Roman', serif",
            maxWidth: 1100,
            //fontSize: 16,
            borderBottom: "1px dotted lightgrey"}} >
            <b>R. Brüel Gabrielsson</b>, Mikhail Yurochkin, Justin Solomon (2022), <a href="https://arxiv.org/pdf/2201.12674.pdf" style={{textDecorationLine: "underline", color: "black", fontStyle: "italic"}} target="_blank">Rewiring with Positional Encodings for Graph Neural Networks</a>, arXiv:2201.12674
          </div>

          <div style={{
            //fontFamily: "Baskerville, 'Baskerville Old Face', 'Goudy Old Style', Garamond, 'Times New Roman', serif",
            maxWidth: 1100,
            //fontSize: 16,
            borderBottom: "1px dotted lightgrey"}} >
            <b>R. Brüel Gabrielsson</b>, Chris Scarvelis, (2022), <a href="https://arxiv.org/pdf/2202.01145.pdf" style={{textDecorationLine: "underline", color: "black", fontStyle: "italic"}} target="_blank">Relative Position Prediction as Pre-training for Text Encoders</a>, arXiv:2202.01145
          </div>

          <div style={{
            //fontFamily: "Baskerville, 'Baskerville Old Face', 'Goudy Old Style', Garamond, 'Times New Roman', serif",
            maxWidth: 1100,
            //fontSize: 16,
            borderBottom: "1px dotted lightgrey"}} >
            <b>R. Brüel Gabrielsson</b>, (2020), <a href="https://arxiv.org/pdf/2003.06706.pdf" style={{textDecorationLine: "underline", color: "black", fontStyle: "italic"}} target="_blank">Universal Function Approximation on Graphs</a>, arXiv:2003.06706 (NeurIPS)
          </div>

          <div style={{
            //fontFamily: "Baskerville, 'Baskerville Old Face', 'Goudy Old Style', Garamond, 'Times New Roman', serif",
            maxWidth: 1100,
            //fontSize: 16,
            borderBottom: "1px dotted lightgrey"}} >
            <b>R. Brüel Gabrielsson</b>, B. Nelson, A. Dwaraknath, P. Skraba, L. Guibas, G. Carlsson, (2019), <a href="https://arxiv.org/pdf/1905.12200.pdf" style={{textDecorationLine: "underline", color: "black", fontStyle: "italic"}} target="_blank">A Topology Layer for Machine Learning</a>, arXiv:1905.12200 (AISTATS)
          </div>

          <div style={{
            //fontFamily: "Baskerville, 'Baskerville Old Face', 'Goudy Old Style', Garamond, 'Times New Roman', serif",
            maxWidth: 1100,
            //fontSize: 16,
            borderBottom: "1px dotted lightgrey"}} >
            <b>R. Brüel Gabrielsson</b> and G. Carlsson, (2018), <a href="https://arxiv.org/pdf/1810.03234.pdf" style={{textDecorationLine: "underline", color: "black", fontStyle: "italic"}} target="_blank">Exposition and Interpretation of the Topology of Neural Networks</a>, arXiv:1810.03234 (ICMLA)
          </div>

          <div style={{
            //fontFamily: "Baskerville, 'Baskerville Old Face', 'Goudy Old Style', Garamond, 'Times New Roman', serif",
            maxWidth: 1100,
            //fontSize: 16,
            borderBottom: "1px dotted lightgrey"}} >
            <b>R. Brüel Gabrielsson</b>, V. Ganapathi-Subramanian, P. Skraba, L. J. Guibas, (2018), <a href="https://arxiv.org/pdf/1811.12543.pdf" style={{textDecorationLine: "underline", color: "black", fontStyle: "italic"}} target="_blank">Topology-Aware Surface Reconstruction for Point Clouds</a>, arXiv:1811.12543 (Computer Graphics Forum)
          </div>

          <div style={{
            //fontFamily: "Baskerville, 'Baskerville Old Face', 'Goudy Old Style', Garamond, 'Times New Roman', serif",
            maxWidth: 1100,
            //fontSize: 16,
            borderBottom: "1px dotted lightgrey"}} >
            G. Carlsson and <b>R. Brüel Gabrielsson</b>, (2018), <a href="https://arxiv.org/pdf/1811.01122.pdf" style={{textDecorationLine: "underline", color: "black", fontStyle: "italic"}} target="_blank">Topological Approaches to Deep Learning</a>, arXiv:1811.01122 (Abel Conference)
          </div>

          <h4>Blog Posts</h4>
          Aug 23, 2019 - My blog post on the Stanford AI blog: <a style={{textDecorationLine: "underline"}}  href="http://ai.stanford.edu/blog/topologylayer/" target="_blank">A Topology Layer for Machine Learning</a>
          <br/>
          Dec 3, 2018 - <a style={{textDecorationLine: "underline"}} href="https://www.ayasdi.com/blog/artificial-intelligence/relationships-geometry-artificial-intelligence/" target="_blank">
          Relationships, Geometry, and Artificial Intelligence</a>
          <br/>
          Sep 9, 2018 - <a style={{textDecorationLine: "underline"}} href="https://www.ayasdi.com/blog/topology/geometric-methods-constructing-efficient-neural-net-architectures/" target="_blank">
          Geometric Methods for Constructing Efficient Neural Net Architectures</a>
          <br/>
          Aug 30, 2018 - <a style={{textDecorationLine: "underline"}} href="https://www.ayasdi.com/blog/artificial-intelligence/incorporating-prior-information-make-neural-nets-learn-2x-faster/" target="_blank">
          Mathematical Acceleration: Incorporating Prior Information to Make Neural Nets Learn 3.5X Faster</a>
          <br/>
          Aug 9, 2018 - <a style={{textDecorationLine: "underline"}} href="https://www.ayasdi.com/blog/artificial-intelligence/going-deeper-understanding-convolutional-neural-networks-learn-using-tda/" target="_blank">
          Going Deeper: Understanding How Convolutional Neural Networks Learn Using TDA</a>
          <br/>
          June 21, 2018 - <a style={{textDecorationLine: "underline"}} href="https://www.ayasdi.com/blog/artificial-intelligence/using-topological-data-analysis-understand-behavior-convolutional-neural-networks/" target="_blank">
          Using Topological Data Analysis to Understand the Behavior of Convolutional Neural Networks</a>

          <h4>Teaching</h4>

          <div style={{
            // fontFamily: "Baskerville, 'Baskerville Old Face', 'Goudy Old Style', Garamond, 'Times New Roman', serif",
            maxWidth: 1000,
            //fontSize: 16,
            borderBottom: "1px dotted lightgrey"}} >
            <b>STANFORD | Course Assistant to Professor Leonidas J. Guibas, 2018</b><br/>
            Course assistant for course CS161 in design and analysis of algorithms.
            Work include lecturing and general teaching duties.
          </div>

          <div style={{
            //fontFamily: "Baskerville, 'Baskerville Old Face', 'Goudy Old Style', Garamond, 'Times New Roman', serif",
            maxWidth: 1000,
            //fontSize: 16,
            borderBottom: "1px dotted lightgrey"}} >
            <b>STANFORD | Course Assistant to Professor Percy Liang, 2017 </b><br/>
            Course assistant for graduate course CS221 in artificial intelligence.
            Work include lecturing and general teaching duties.
          </div>

          <div style={{
            // fontFamily: "Baskerville, 'Baskerville Old Face', 'Goudy Old Style', Garamond, 'Times New Roman', serif",
            maxWidth: 1000,
            //fontSize: 16,
            borderBottom: "1px dotted lightgrey"}} >
            <b>STANFORD | Introduction to Computing, CS2C, Instructor, 2015 </b>
          </div>

          </div>
        </div>
      </div>
    );
  }
}

class Projects extends Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {

    return (
      <div className="no-pad-bot section" id="index-banner"
        style={{
          height: "100vh",
          background: "linear-gradient(rgba(8, 93, 255, 0.1) 20%, rgba(244, 244, 66, 0) 70%) 0% 0% / cover black",
          backgroundSize: "cover",
          overflowY: "auto",
        }}
      >
        <div className="container"
          style={{
            alignItems: "center",
            justifyContent: "center",
            display: "flex",
            flexDirection: "column",
          }}>
          <div style={{paddingTop: 50}}>
            <ListItems views={
              [
                <a target="_blank" href="teenAI">
                  <div className="card-image">
                      <img src="assets/img/teenager.jpg" alt="3" />
                  </div>
                  <div className="card-content">
                      <span className="card-title activator grey-text text-darken-4">Teen AI<i className="mdi-navigation-more-vert right"></i></span>
                      <span className="grey-text text-darken-4">Have we beat the Turing test?</span>
                  </div>
                </a>
              ,]
            } />
          </div>
        </div>
      </div>
    );
  }
}

class Film extends Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="no-pad-bot section" id="index-banner"
        style={{
          height: "100vh",
          background: "black",
          backgroundSize: "cover",
          overflowY: "auto",
        }}
      >
          <div className="container"
              style={{
                alignItems: "center",
                justifyContent: "center",
                display: "flex",
              }}>
              <div className="video-container-1" style={{}} >
                <iframe
                  width="560"
                  height="315"
                  src="https://www.youtube.com/embed/O2h_k9bY1TE"
                  title="YouTube video player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  allowFullScreen
                />
              </div>
          </div>
      </div>
    );
  }
}


class ListItems extends Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const views = this.props.views.map((view) => {
      return (
        <div className="col s12 m4 l4">
            <div className="card">
              {view}
            </div>
        </div>
      );
    });
    return (
      <div className="row">
          {views}
      </div>
    );
  }
}

class Music extends Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="no-pad-bot section" id="index-banner"
        style={{
          height: "100vh",
          background: "linear-gradient(180deg, rgba(113,11,146, 0.45) 10%, rgba(255,255,255, 0) 70%), red",
          backgroundSize: "cover",
          overflowY: "auto",
        }}
      >
        <div className="container"
          style={{
            alignItems: "center",
            justifyContent: "center",
            display: "flex",
            flexDirection: "column",
          }}
          >
            <div style={{margin: 20, marginTop: 50}}>
              <iframe width="100%" height="450" scrolling="no" frameBorder="no" src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/users/306718695&amp;auto_play=false&amp;hide_related=false&amp;show_comments=true&amp;show_user=true&amp;show_reposts=false&amp;visual=true"></iframe>
            </div>
            <div>
              <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/dyeAfH4Mxqg?rel=0"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            />
            </div>
        </div>
      </div>
    );
  }
}

class Paintings extends Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {

    return (
      <div className="no-pad-bot section" id="index-banner"
        style={{
          height: "100vh",
          background: "linear-gradient(rgba(8, 93, 92, 0.3) 2%, rgba(244, 244, 66, 0) 70%) 0% 0% / cover black",
          backgroundSize: "cover",
          overflowY: "auto",
        }}
      >
        <div className="container"
          style={{
            alignItems: "center",
            justifyContent: "center",
            display: "flex",
            flexDirection: "column",
          }}>
          <div style={{paddingTop: 50}}>
            <ListItems views={
              [<div className="card-image">
                <a target="_blank" href="assets/img/paintings/im.jpg">
                  <img src="assets/img/paintings/im.jpg" alt="3" />
                </a>
              </div>,
              <div className="card-image">
                <a target="_blank" href="assets/img/paintings/bed.jpeg">
                  <img src="assets/img/paintings/bed.jpeg" alt="3" />
                </a>
              </div>,
              <div className="card-image">
                <a target="_blank" href="assets/img/paintings/davinci.jpg">
                  <img src="assets/img/paintings/davinci.jpg" alt="4" />
                </a>
              </div>,
              <div className="card-image">
                <a target="_blank" href="assets/img/paintings/naked.jpg">
                  <img src="assets/img/paintings/naked.jpg" alt="5" />
                </a>
              </div>
              ]
            } />
          </div>
        </div>
      </div>
    );
  }
}

class Photography extends Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="no-pad-bot section" id="index-banner"
        style={{
          height: "100vh",
          background: "linear-gradient(180deg, rgba(66, 244, 220, 0.6) 40%, rgba(255,255,255, 0) 70%), white",
          backgroundSize: "cover",
          overflowY: "auto",
        }}
      >
        <div className="container"
          style={{
            alignItems: "center",
            justifyContent: "center",
            display: "flex",
          }}>
          <div style={{paddingTop: 50}}>
            <ListItems views={
              [<div className="card-image">
              <a target="_blank" href="assets/img/photography/1.jpg">
                <img src="./assets/img/photography/1.jpg" alt="1" />
              </a>
              </div>,
              <div className="card-image">
              <a target="_blank" href="assets/img/photography/2.jpg">
                <img src="./assets/img/photography/2.jpg" alt="2" />
              </a>
              </div>,
              <div className="card-image">
              <a target="_blank" href="assets/img/photography/3.jpg">
                <img src="./assets/img/photography/3.jpg" alt="3" />
              </a>
              </div>,
              <div className="card-image"><a target="_blank" href="assets/img/photography/4.jpg">
                <img src="./assets/img/photography/4.jpg" alt="4" />
              </a>
              </div>,
              <div className="card-image">
              <a target="_blank" href="assets/img/photography/taco.jpg">
                <img src="./assets/img/photography/taco.jpg" alt="5" />
              </a>
              </div>,]
            } />
          </div>
        </div>
      </div>
    );
  }
}

class About extends Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="no-pad-bot section" id="index-banner"
        style={{
          height: "100vh",
          background: "linear-gradient(180deg, rgba(113,11,146, 0.5) 50%, rgba(255,255,255, 0.1) 99%), url('./assets/img/rose.png') repeat center center, gold",
          // backgroundSize: "80px 60px",
          overflowY: "auto",
        }}
      >
        <div className="container"
          style={{
            alignItems: "center",
            justifyContent: "center",
            display: "flex",
            height: "100%",
            flexDirection: "column",
          }}>
          <div style={{color: "white", fontWeight: "300"}}>
            <p>Nothing on this site should be construed as an endorsement of the views contained therein.</p>
            <p>A collection of anonymous work from a diverse set of people.</p>
            <p>We just reached 1,000 visitors per day. Thank you.</p>
            <div style={{color: "white", fontWeight: "bold", paddingTop: 10}}> rgabriel@stanford.edu </div>
          </div>

        </div>
      </div>
    );

  }
}

class Header extends Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    utils.activate_header_menu();
  }

  render() {
    const title = "Rickard Brüel Gabrielsson";
    const links = [
      //{title: "THOUGHTS", page: "thoughts"},
      //{title: "PROJECTS", page: "projects"},
      //{title: "FILM", page: "film"},
      {title: "RESEARCH & TEACHING", page: "research-teaching"},
      {title: "MUSIC", page: "music"},
      {title: "PAINT", page: "paintings"},
      //{title: "PHOTO", page: "photography"},
      // {title: "ABOUT", page: "about"},
    ];
    const defaultSelectedStyle = {borderBottom: "3px solid white"};
    const lightBackground = this.props.page === "thoughts" || this.props.page === "photography" || this.props.page === "research-teaching";
    const generateItems = (type = "main") => {
      const selectedStyle = defaultSelectedStyle;
      const selectedStyleMobile = {borderBottom: "1px solid black"};
      const styleToUse = type === "main" ? selectedStyle : selectedStyleMobile;
      let i = 0;
      return links.map((item) => {
        i += 1;
        let extraStyle = {};
        if (item.page === this.props.page) {
          extraStyle = styleToUse;
        }
        return (
          <li key={i}>
            <Link to={`/${item.page}`}>
              <span style={extraStyle}>
                <span style={{padding: 4, color: lightBackground || type === "mobile" ? "black" : "white"}}>{`${item.title}`}</span>
              </span></Link>
          </li>
        );
      });
    }
    const listItems = generateItems();
    const mobileListItems = generateItems("mobile");


    return (
      <div>
        <div className="navbar-fixed" style={{position: "absolute"}}>
          <nav id="nav_f" className="" role="navigation" style={{backgroundColor: "transparent"}}>
              <div className="container">
                  <div className="nav-wrapper">
                      <span >
                        <Link className="" id="" to="/" >
                          <span style={
                            this.props.page === "" ? defaultSelectedStyle : {}
                          } >
                            <span style={{
                              padding: 4,
                              fontWeight: 300,
                              color: lightBackground ? "black" : "white",
                            }}>{title}</span>
                          </span>
                        </Link>
                      </span>
                      <ul className="right hide-on-med-and-down">
                        {listItems}
                      </ul>
                  <a href="#" data-activates="nav-mobile" className="button-collapse"><i className="material-icons">menu</i></a>
                  </div>
              </div>
          </nav>
        </div>
        <ul id="nav-mobile" className="side-nav">
          {mobileListItems}
        </ul>
      </div>
    );
  }
}

class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      page: "index",
    };
  }

  render() {
    // window.location.href CHECK HREF AND SERVE DIFFERENT DEPENDING ON IT
    return (
      <Router>
        <div>
            <Route exact path="/" render={(props) =>
              <div className="">
                  <Header page="" />
                  <Main />
              </div>
            } />
            <Route path="/teenAI" component={TeenAI}/>
            <Route path="/:page" render={(props) => {
              if (props.match.params.page === "teenAI") return <div />;
              return (
                <div className="">
                    <Header page={props.match.params.page} />
                    <Main />
                </div>
              );
            }} />

          </div>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js